import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const blogs = {
	// 获取攻略列表数据
	getBlogData: payload => {
		return api.get(proxyApi + '/v3/pages', payload)
	},
	// 获取攻略详情
	getBlogDetail: token => {
		return api.get(proxyApi + `/v3/pages/${ token }`)
	},
	// 获取攻略详情热门列表
	getHotPages: () => {
		return api.get(proxyApi + `/v3/hot_pages`)
	},
	// 获取发布列表
	getReleaseList: payload => {
		return api.get(proxyApi + '/v3/bbs/my_news', payload)
	},
	// 获取收藏列表
	getCollectionList: payload => {
		return api.get(proxyApi + '/v3/bbs/my_collections', payload)
	},
	// 获取动态列表
	getInteractiveList: payload => {
		return api.get(proxyApi + '/v3/bbs/my_actions', payload)
	},
	// 获取消息列表
	getSystemMessage: payload => {
		return api.get(proxyApi + '/v3/bbs/my_notice', payload)
	},
	// 攻略收藏
	updateBlogCollect: (token, payload) => {
		return api.put(proxyApi + `/v3/bbs/pages/${ token }/collect_status`, payload)
	},
	// 攻略点赞
	updateBlogLike: (token, payload) => {
		return api.put(proxyApi + `/v3/bbs/pages/${ token }/like_status`, payload)
	}
}

export default blogs
